var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationBlackIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49841 11.5596L3.4906 11.5517L3.4825 11.5441C2.23561 10.3722 1.6 8.74003 1.6 6.98908C1.6 3.41969 4.39624 0.6 7.90531 0.6C11.4171 0.6 14.2022 3.41908 14.1122 6.97388L14.112 6.98148V6.98908C14.112 8.74003 13.4764 10.3722 12.2295 11.5441L12.0404 11.7218V11.7462C11.9355 11.8483 11.7844 11.9905 11.5992 12.162C11.2215 12.5118 10.7152 12.9714 10.2038 13.4329C9.75126 13.8412 9.286 14.2587 8.90565 14.6C8.44317 15.015 8.10623 15.3174 8.07038 15.3537C8.06263 15.3615 8.01077 15.4 7.89298 15.4C7.78841 15.4 7.68054 15.3677 7.59737 15.3116C7.39213 15.1198 6.55106 14.3516 5.69921 13.5736L5.54783 13.4353C5.04219 12.9735 4.53684 12.5119 4.15173 12.1595C3.95914 11.9833 3.79694 11.8347 3.67994 11.7271C3.5804 11.6356 3.52476 11.584 3.50584 11.5665C3.50062 11.5616 3.49819 11.5594 3.49841 11.5596Z",
    stroke: "#717171",
    strokeWidth: 1.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.6,
    y: 5.6,
    width: 2.8,
    height: 2.8,
    rx: 1.4,
    stroke: "#717171",
    strokeWidth: 1.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBlackIcon);
export default __webpack_public_path__ + "static/media/location-black-icon.e4bfe0a6a850629f201209880c33fc8d.svg";
export { ForwardRef as ReactComponent };